export default {
    setVinData: (state, payload) => state.vinData = payload,
    clearVinData: (state) => state.vinData = "",
    setSubmittedVinData: (state, payload) => state.submittedVinData = payload,
    clearSubmittedVinData: (state) => state.submittedVinData = [],
}